import { httpMethodByAction, buildHeaders } from '../utils/http'
import { getAttributeValue } from '../utils/params'
import { loadingProgress } from '../utils/helpers'

const V1_URL = '/api/v1/service_inspections_form_filled/inspection_data_images'
const V4_URL = '/api/v4/service_inspections_form_filled/inspection_data_images'

const useNewUploader = () => {
  try {
    return localStorage.getItem('new_uploader') === '1'
  } catch (_e) {
    return false
  }
}

const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(',')
  const mimeMatch = header.match(/data:([^;]+);base64/)
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg'
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return new Blob([bytes], { type: mime })
}

const extFromMime = (mime) => {
  const map = { 'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/png': 'png', 'image/webp': 'webp' }
  return map[mime] || 'jpg'
}

export default class InspectionImageCreator {
  constructor(token) {
    this.token = token
    this.multipart = useNewUploader()
    this.resourceUrl = this.multipart ? V4_URL : V1_URL

    if (this.multipart) {
      const h = buildHeaders(token)
      h.delete('Content-Type')
      this.headers = h
    } else {
      this.headers = buildHeaders(token)
    }
  }

  createMany(inspectionGuid, inspectionForm) {
    const imageForms = inspectionForm.querySelectorAll('.new-image-form')
    let loadingProgressPercetage = 0
    loadingProgress(1)

    return Promise.all(Array.from(imageForms).map((form) => {
      const imageAttr = getAttributeValue(form, 'inspection_data_image', 'image')
      const guid = getAttributeValue(form, 'inspection_data_image', 'guid')
      const caption = getAttributeValue(form, 'inspection_data_image', 'caption')
      const nowIso = new Date().toISOString()

      return new Promise((resolve, reject) => {
        const fetchOptions = {
          method: httpMethodByAction('new'),
          headers: this.headers,
        }

        if (this.multipart) {
          const blob = dataUrlToBlob(imageAttr)
          const filename = `${guid}.${extFromMime(blob.type)}`
          const body = new FormData()
          body.append('guid', guid)
          body.append('inspection_data_guid', inspectionGuid)
          body.append('image', blob, filename)
          body.append('caption', caption || '')
          body.append('created_at', nowIso)
          body.append('updated_at', nowIso)
          fetchOptions.body = body
        } else {
          const params = {
            guid: guid,
            inspection_data_guid: inspectionGuid,
            image: imageAttr.substring(imageAttr.indexOf(',') + 1),
            caption: caption,
            created_at: nowIso,
            updated_at: nowIso
          }
          fetchOptions.body = JSON.stringify(params)
        }

        fetch(this.resourceUrl, fetchOptions).then((response) => {
          response.json().then((data) => {
            loadingProgressPercetage =  loadingProgressPercetage + (90 / imageForms.length)
            loadingProgress(loadingProgressPercetage)

            if(response.ok) resolve(data)
            else reject(data)
          })
        }).catch(error => {
          reject(error)
        })
      })
    }))
  }
}
